import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  row: {
    marginBottom: '0.5rem'
  },

  input: {
    outline: 'none',
    border: 'none',
    width: '100%'
  },

  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '0.75rem',

    '& > :last-child': {
      marginLeft: '0.5rem'
    }
  },

  button: {
    padding: '0.705rem 1.875rem',
    fontSize: theme.size.sm
  }
}))

export default useStyles
